<template>
    <div id="question-edit" class="page-layout__inner w-100">
        <div class="row w-100">
            <div class="section col-md-12">
                <QuestionCreateComponent v-on:update-test="updateHeading" :action="'edit'"/>
            </div>
        </div>
    </div>
</template>

<script>
    import QuestionCreateComponent from "./Components/QuestionCreateComponent";
    import questionMixin from "./mixins/question";

    export default {
        name: "Edit",
        components: {QuestionCreateComponent},
        mixins: [questionMixin],
        created() {
            if (this.testId) {
                this.fetchQuestionTesting(this.testId).then(testing => {
                    this.$store.dispatch('test/setTest', testing);
                    this.setHeadings({
                        title: this.getTranslation('editingQuestion'),
                        breadcrumbs: [
                            {
                                label: this.getTranslation('testingTypes'),
                                route: {name: 'api.testing.getList'}
                            },
                            {
                                label: testing.title,
                            }
                        ],
                        toBack: {
                            label: testing.title,
                            route: {name: 'api.testing.get', params: {id: testing.id}}
                        }
                    })
                });
            }
        }
    }
</script>

<style scoped>

</style>